import { createContext, useContext, useEffect, useMemo, type ReactNode } from 'react'
import { useGetCurrentManager } from './backend/interviews'
import type { Manager } from '../utils/interviews'

type ManagerContextValue = {
  manager: Manager | null
  loading: boolean
  linked: boolean
  name: string | null
}

const ManagerContext = createContext<ManagerContextValue>({
  manager: null,
  loading: true,
  linked: false,
  name: null,
})

export function ManagerProvider({ children }: { children: ReactNode }) {
  const { data, loading, trigger } = useGetCurrentManager()

  useEffect(() => {
    trigger({})
  }, [trigger])

  const value = useMemo<ManagerContextValue>(() => {
    const manager = (data as Manager | null | undefined) ?? null
    const name = manager
      ? [manager.first_name, manager.last_name].filter(Boolean).join(' ').trim() || null
      : null
    return { manager, loading, linked: manager != null, name }
  }, [data, loading])

  return <ManagerContext.Provider value={value}>{children}</ManagerContext.Provider>
}

export function useManager() {
  return useContext(ManagerContext)
}
